import type { PendingAgentTask } from '../../../stores/table-store';

/**
 * The tasks a Create form declared, as the agents to build after the
 * solution loads (`tableStore.markPendingAgentDrafts`): named ones only, each
 * with its Example Phrases split on `|` or a new line.
 */
export const declaredAgentTasks = (
  tasks: { name: string; description?: string }[] = []
): PendingAgentTask[] =>
  tasks
    .filter((t) => t.name.trim())
    .map((t) => ({
      name: t.name.trim(),
      phrases: (t.description ?? '')
        .split(/[|\n]/)
        .map((p) => p.trim())
        .filter(Boolean),
    }));

/** What the AI drafts an agent from when Create has no conversation to give it. */
export const createBrief = ({
  brandName,
  otherInformation,
}: {
  brandName?: string;
  otherInformation?: string;
}): string =>
  [brandName && `Brand: ${brandName}`, otherInformation]
    .filter(Boolean)
    .join('\n\n');
